import WebComponent from '../../WebComponent'
import OnboardingService from './OnboardingService'
import {html} from '@isceco/widget-library2/external/lit'
import BerechtigungUtil from '../../services/BerechtigungUtil'
import Navigation from '../Navigation/Navigation'
import BenutzerprofilDto from '../Authorization/BenutzerprofilDto'
import '@isceco/widget-library2/basic-elements/Card/Card'

export default class Onboarding extends WebComponent {

  constructor() {
    super()
    this.onboardingService = new OnboardingService()
    this.onboardingSuccess = false
  }

  get translationFile() {
    return './views/Onboarding/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    this.render()
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('page.title')}">
      </isceco-title>
      <p>${this.i18n.translate('page.welcome.text.1')}</p>
      <p>${this.i18n.translate('page.welcome.text.2')}</p>
      <isceco-form id="onboarding-form"
                   submit-button-text="${this.i18n.translate('form.button.submit')}"
                   @submit="${e => this._handleSubmit(e)}"
      >
        <div slot="form-elements" class="form-container">
          <isceco-text-input name="token"
                             label="${this.i18n.translate('form.input.token')}"
                             maxlength="15" required
                             autocomplete="off"
                             @keyup="${event => this._formatInputToken(event)}"
          ></isceco-text-input>
        </div>
      </isceco-form>
      ${this._renderSuccessMessage()}
    `
  }

  _renderSuccessMessage() {
    if (this.onboardingSuccess) {
      return html`
        <br/>
        <isceco-card style="background-color: var(--isceco-color-green-100)" id="onboarding-success">
          ${this.i18n.translate('onboarding.success.message')}<br/>
          <isceco-link text="${this.i18n.translate('onboarding.success.link')}"
                       icon="hand point right"
                       @click="${() => Onboarding.reloadHomepage()}"
          ></isceco-link>
        </isceco-card>
      `
    } else {
      return html``
    }
  }

  _formatInputToken = event => {
    const value = event.detail.value.replaceAll('-', '').toUpperCase()
    let part1 = value.substring(0, 4)
    let part2 = value.substring(4, 9)
    const part3 = value.substring(9, 13)
    part1 = part1.length === 4 ? `${part1}-` : part1
    part2 = part2.length === 5 ? `${part2}-` : part2
    event.target.value = `${part1}${part2}${part3}`
  }

  _handleSubmit = event => {
    // deactivate submit button
    event.target.setAttribute('disabled', true)
    this.render()
    const form = event.detail
    new OnboardingService().create(form)
      .then(response => this._handleOnboardingSuccess(response))
      .catch(_ => {
        // reactivate submit button
        event.target.removeAttribute('disabled')
      })
      .finally(() => this.render())
  }

  _handleOnboardingSuccess = response => {
    new BerechtigungUtil().setActiveProfile(new BenutzerprofilDto(response))
    this.onboardingSuccess = true
    setTimeout(() => Onboarding.reloadHomepage(), 5000)
  }

  static reloadHomepage = () => {
    navigate({to: Navigation.ROUTES.dashboard.url, allow: true})
    window.location.reload()
  }

}
customElements.define('eko-frontend-onboarding', Onboarding)
